import { render, staticRenderFns } from "./ShiftClots.vue?vue&type=template&id=24e76c49&"
import script from "./ShiftClots.vue?vue&type=script&lang=ts&"
export * from "./ShiftClots.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftClots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports